import type { RouteRecordRaw } from 'vue-router';
import { healthFundRoutesDictionary } from './health-fund-routes.dictionary.ts';

export const healthFundRoutesConfig: RouteRecordRaw = {
  ...healthFundRoutesDictionary.healthFund.root,
  redirect: { name: healthFundRoutesDictionary.healthFund.list.name },
  children: [
    {
      ...healthFundRoutesDictionary.healthFund.list,
      component: () => import('../pages/List/HealthFundOrderListPage.vue'),
    },
    {
      ...healthFundRoutesDictionary.healthFund.detail,
      component: () => import('../pages/Detail/HealthFundOrderDetailPage.vue'),
      props: true,
    },
  ],
};
